// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-simple-screen',
    computed: {
        getImageStyles() {
            return {
                'background-image': `url(${host.config.loginPageImage})`
            };
        },
        footerMenuEntriesRight() {
            return this.$host.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    }
});
// #endregion
